import { IAppSettings } from 'models/config'

interface CustomWindow extends Window {
  appSettings: IAppSettings
}

declare const window: CustomWindow

export const config = window.appSettings
